import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Profit And Loss";
const description = `A P&L (Profit and Loss) report is a financial summary of a business's revenues and expenses over a specific period. It is crucial for understanding a company's financial health, as it shows whether the business is making a profit or a loss. The key components, such as Operating Income, Cost of Goods Sold, and Operating Expenses, highlight the profitability of the core business, while Non-Operating Income and Expenses show other financial activities. This report is essential for business owners to make informed decisions about pricing, cost management, and future investments, and it is a key document for attracting investors and securing loans.`;

const images = [
    '/images/reports/business-overview/profit-and-loss/profit-and-loss.png', // 0
];


const ProfitAndLoss: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">
                {/* Chart of Accounts */}
                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfitAndLoss;
